import { connect } from 'react-redux';
import Component from './component';

const mapStateToProps = () => ({});

export default connect(mapStateToProps, null)(Component);
